import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleUpSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-up-small, dropdown, caret" maskId="round-filled-radius-1-stroke-1.5-IconChevronTriangleUpSmall"><path d="M9.8007 13.7501C8.74816 13.7501 8.16683 12.5287 8.83056 11.7118L11.0301 9.00473C11.5303 8.38905 12.4701 8.38905 12.9704 9.00473L15.1699 11.7118C15.8336 12.5287 15.2523 13.7501 14.1997 13.7501H9.8007Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpSmall;
